// extracted by mini-css-extract-plugin
export default {"column":"Session_column__Yg6h4","allGroupsContainer":"Session_allGroupsContainer__UmCDP","groupContainer":"Session_groupContainer__l3EAz"};